import React from "react";

const TappaCard = ({ tappa, index, mapStatus, onInfoClick, onUpdateClick }) => {
    // Check if we're on mobile
    const isMobile = window.innerWidth <= 768;
    return (
        <div
            style={{
                position: "relative",
                width: isMobile ? "100%" : "33%",
                marginBottom: "20px",
                padding: "5px",
            }}
        >
            <div
                className="div-cammini"
                style={{
                    display: "inline-block",
                    backgroundColor: "#ffffff",
                    position: "relative",
                    borderRadius: "20px",
                    padding: "19px",
                    width: "100%",
                }}
            >
                <p
                    style={{
                        paddingTop: "20px",
                        color: "#B1B1B1",
                        fontWeight: "300",
                        fontSize: "1em",
                        marginBottom: "3px",
                    }}
                >
                    {new Date(tappa.data_prenotazione).toLocaleDateString()}
                </p>
                <p
                    style={{
                        color: "#2F2F2F",
                        fontWeight: "600",
                        fontSize: "1em",
                        marginBottom: "3px",
                    }}
                >
                    {tappa.nome_tappa_inizio} - {tappa.nome_tappa_fine}
                </p>
                <p
                    style={{
                        color: mapStatus[tappa.stato].color,
                        fontWeight: "bold",
                        fontSize: "1em",
                        marginBottom: "3px",
                    }}
                >
                    Stato: {mapStatus[tappa.stato].name}
                </p>
                <p
                    style={{
                        color: "#2F2F2F",
                        fontWeight: "300",
                        fontSize: "1em",
                        marginBottom: "3px",
                        fontStyle: "italic",
                    }}
                >
                    Costo: {tappa.costo_prenotazione_singola}€
                </p>
                <p
                    style={{
                        color: "#2F2F2F",
                        fontWeight: "300",
                        fontSize: "1em",
                        marginBottom: "3px",
                        fontStyle: "italic",
                    }}
                >
                    Bagagli: {tappa.quantita_bagagli}
                </p>

                {/* Accommodation information */}
                {tappa.alloggio_inizio_nome && (
                    <p
                        style={{
                            color: "#2F2F2F",
                            fontWeight: "500",
                            fontSize: "0.95em",
                            marginBottom: "3px",
                            marginTop: "10px",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px"
                        }}
                    >
                        <span style={{ color: "#666", fontWeight: "400" }}>Ritiro:</span>
                        {tappa.alloggio_inizio_nome}
                        {tappa.alloggio_inizio_attivo !== 0 && (
                            <span
                                style={{
                                    display: "inline-block",
                                    width: "8px",
                                    height: "8px",
                                    borderRadius: "50%",
                                    backgroundColor: "#FF9D00",
                                    marginLeft: "4px"
                                }}
                                title="Struttura da confermare"
                            />
                        )}
                    </p>
                )}
                {tappa.alloggio_fine_nome && (
                    <p
                        style={{
                            color: "#2F2F2F",
                            fontWeight: "500",
                            fontSize: "0.95em",
                            marginBottom: "3px",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px"
                        }}
                    >
                        <span style={{ color: "#666", fontWeight: "400" }}>Consegna:</span>
                        {tappa.alloggio_fine_nome}
                        {tappa.alloggio_fine_attivo !== 0 && (
                            <span
                                style={{
                                    display: "inline-block",
                                    width: "8px",
                                    height: "8px",
                                    borderRadius: "50%",
                                    backgroundColor: "#FF9D00",
                                    marginLeft: "4px"
                                }}
                                title="Struttura da confermare"
                            />
                        )}
                    </p>
                )}

                {/* Tracking buttons - only show if tracking links exist */}
                {(tappa.tracking_link_pickup || tappa.tracking_link_delivery) && (
                    <div style={{
                        marginTop: "15px",
                        marginBottom: "15px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px"
                    }}>
                        {tappa.tracking_link_pickup && (
                            <a
                                href={tappa.tracking_link_pickup}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "#FF9D00",
                                    color: "white",
                                    padding: isMobile ? "10px 14px" : "8px 12px",
                                    borderRadius: "10px",
                                    textDecoration: "none",
                                    fontSize: isMobile ? "0.9em" : "0.85em",
                                    fontWeight: "600",
                                    transition: "all 0.2s",
                                    border: "none",
                                    cursor: "pointer",
                                    minHeight: isMobile ? "44px" : "auto"
                                }}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#E68D00"}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#FF9D00"}
                            >
                                <span style={{ marginRight: "6px" }}>📦</span>
                                Traccia Ritiro
                            </a>
                        )}
                        {tappa.tracking_link_delivery && (
                            <a
                                href={tappa.tracking_link_delivery}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "#5552f3",
                                    color: "white",
                                    padding: isMobile ? "10px 14px" : "8px 12px",
                                    borderRadius: "10px",
                                    textDecoration: "none",
                                    fontSize: isMobile ? "0.9em" : "0.85em",
                                    fontWeight: "600",
                                    transition: "all 0.2s",
                                    border: "none",
                                    cursor: "pointer",
                                    minHeight: isMobile ? "44px" : "auto"
                                }}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#4441d9"}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#5552f3"}
                            >
                                <span style={{ marginRight: "6px" }}>🚚</span>
                                Traccia Consegna
                            </a>
                        )}
                    </div>
                )}

                <div>
                    <button
                        onClick={onInfoClick}
                        style={{
                            backgroundColor: "transparent",
                            boxShadow: "none",
                            border: "none",
                            paddingLeft: "0",
                        }}
                    >
                        <img
                            style={{
                                width: "30px",
                                marginRight: "5px",
                            }}
                            src="./infoTable.svg"
                        />
                    </button>
                    <button
                        onClick={onUpdateClick}
                        style={{
                            backgroundColor: "transparent",
                            border: "none",
                            boxShadow: "none",
                            paddingLeft: "0",
                        }}
                    >
                        <img style={{ width: "30px" }} src="./updateTable.svg" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TappaCard;